import { CommonModule } from "@angular/common";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { translationChunksConfig } from "@spartacus/assets";
import { BaseSiteService, CmsConfig, ConfigModule, I18nModule, provideConfig } from "@spartacus/core";
import { RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings, RECAPTCHA_LANGUAGE, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { NeedAssistanceModule } from "../shared/modules/need-assistance/need-assistance.module";
import { ForgotUserPasswordComponent } from "./forgot-user-password/forgot-user-password.component";
import { HelpHintRecoveryQuestionComponent } from "./help-hint-recovery-question/help-hint-recovery-question.component";
import { LoginPageComponent } from "./login-page/login-page.component";
import { SetPasswordComponent } from "./set-password/set-password.component";
import { UserDataRecoveryActionComponent } from "./user-data-recovery-action/user-data-recovery-action.component";
import { take } from "rxjs/operators";
const globalSettings: RecaptchaSettings = { siteKey: '' };
const startIndex = 6;
const totalCharsNeeded = 2;
const language = location.pathname.substr(startIndex, totalCharsNeeded);

function loadRecaptcha(baseSiteService: BaseSiteService) {
  return () => baseSiteService.get().pipe(take(1)).subscribe((baseSite: any) => {
    globalSettings.siteKey = baseSite?.captchaConfig?.publicKey;
  })
}

@NgModule({
  declarations: [
    ForgotUserPasswordComponent,
    SetPasswordComponent,
    HelpHintRecoveryQuestionComponent,
    UserDataRecoveryActionComponent,
    LoginPageComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    I18nModule,
    NeedAssistanceModule,
    NgbModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        LoginHelpComponent: {
          component: ForgotUserPasswordComponent,
        },
        UserNameRecoverySuccessComponent: {
          component: UserDataRecoveryActionComponent,
        },
        HintQuestionAnswerComponent: {
          component: HelpHintRecoveryQuestionComponent,
        },
        ForgotPasswordComponent: {
          component: SetPasswordComponent,
        },
        LoginPageReferenceComponent: {
          component: LoginPageComponent,
        },
      },
    } as CmsConfig),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      deps: [BaseSiteService],
      useFactory: loadRecaptcha,
      multi: true,
    },
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: globalSettings,
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: language,
    },
  ],
})
export class ForgotUserPasswordModule { }
